import * as React from 'react';
import BMI from './BMI';
import FormControl from '../../Form/FormControl';
import { useFormContext } from 'react-hook-form';

interface BMIFormControlProps {
	weightKey: string;
	heightKey: string;
	name: string;
	label?: string;
}

const BMIFormControl: React.FC<BMIFormControlProps> = props => {
	const { weightKey, heightKey, name, label } = props;

	const { watch } = useFormContext();
	const weight = watch(weightKey);
	const height = watch(heightKey);

	return (
		<FormControl name={name} label={label} hideRequired={true}>
			<BMI weight={parseFloat(weight)} height={parseFloat(height)} />
		</FormControl>
	);
};

export default BMIFormControl;
